import { colors } from '../../../constants/index';

const componentToHex = (c) => {
    const hex = (+c).toString(16);

    return hex.length === 1 ? `0${hex}` : hex;
};

export const convertRgbToHex = (rgb) => {
    const colorCodes = rgb.replace(' ', '').split(',');

    if (colorCodes.length > 2) {
        return `#${componentToHex(colorCodes[0])}${componentToHex(colorCodes[1])}${componentToHex(colorCodes[2])}`;
    }
    return '';
};

export const getStylesValueByKey = (variable) => {
    const rootElement = document.documentElement;
    let lightModeBodyElement = document.querySelector('.theme-light');
    if (lightModeBodyElement === null) {
        lightModeBodyElement = document.querySelector('.theme-dark');
    }
    const computedStyles = window.getComputedStyle(document.body);

    if (variable) {
        const key = variable.slice(4, variable.length - 1);

        if (lightModeBodyElement.style.getPropertyValue(key)) {
            return lightModeBodyElement.style.getPropertyValue(key);
        }

        if (rootElement.style.getPropertyValue(key)) {
            return rootElement.style.getPropertyValue(key);
        }

        if (computedStyles.getPropertyValue(key)) {
            return computedStyles.getPropertyValue(key);
        }
    }

    return '';
};


export const customWidgetParams = {};

export const customWidgetOptions = (colorTheme) => {
    let primaryColor = convertRgbToHex(getStylesValueByKey(colors.dark.chart.primary));
    let upColor = convertRgbToHex(getStylesValueByKey(colors.dark.chart.up));
    let downColor = convertRgbToHex(getStylesValueByKey(colors.dark.chart.down));
    let background = convertRgbToHex(getStylesValueByKey(colors.dark.chart.background));
    let gridColor = convertRgbToHex(getStylesValueByKey(colors.dark.chart.gridColor));
    let theme = 'Dark';
    if (colorTheme === 'light') {
        primaryColor = convertRgbToHex(getStylesValueByKey(colors.light.chart.primary));
        upColor = convertRgbToHex(getStylesValueByKey(colors.light.chart.up));
        downColor = convertRgbToHex(getStylesValueByKey(colors.light.chart.down));
        background = convertRgbToHex(getStylesValueByKey(colors.light.chart.background));
        gridColor = convertRgbToHex(getStylesValueByKey(colors.light.chart.gridColor));
        theme = 'Light';
    }
    return {
        toolbar_bg: background,
        loading_screen: {
            backgroundColor: background,
        },
        overrides: {
            ['symbolWatermarkProperties.color']: primaryColor,
            ['mainSeriesProperties.candleStyle.upColor']: upColor,
            ['mainSeriesProperties.candleStyle.downColor']: downColor,
            ['mainSeriesProperties.candleStyle.borderUpColor']: upColor,
            ['mainSeriesProperties.candleStyle.borderDownColor']: downColor,
            ['mainSeriesProperties.candleStyle.wickUpColor']: upColor,
            ['mainSeriesProperties.candleStyle.wickDownColor']: downColor,
            ['paneProperties.background']: background,
            ['paneProperties.vertGridProperties.color']: gridColor,
            ['paneProperties.vertGridProperties.style']: 1,
            ['paneProperties.horzGridProperties.color']: gridColor,
            ['paneProperties.horzGridProperties.style']: 1,
            ['paneProperties.crossHairProperties.color']: gridColor,
            ['paneProperties.crossHairProperties.width']: 1,
            ['paneProperties.crossHairProperties.style']: 1,
            ['scalesProperties.backgroundColor']: background,
        },
        studies_overrides: {
            ['volume.volume.color.0']: downColor,
            ['volume.volume.color.1']: upColor,
        },
        theme: theme,
    };
};
